// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroller__container[data-v-0c7c9836]{position:absolute;bottom:0;height:25px;margin:auto;background-color:#e2e4e9}.scroller__grip[data-v-0c7c9836]{position:relative;height:25px;width:50px;cursor:pointer;border:solid 1px #8b8b8b;border-radius:15px}\n", ""]);
// Exports
module.exports = exports;
